import {LOAD_CURRENT_USER, TOGGLE_EMAIL_CONFIRMATION} from 'action_types/userActionTypes';
import {PENDING_USER_STATUS} from 'constants/userStatuses';
import initialState from './initialState';
import helper from './reducerHelper';

const userReducer = (state = initialState.user, action) => {
  return helper.handleActions(state, action, {
    [LOAD_CURRENT_USER](state, payload) {
      const user = payload.user;

      if (user) {
        let isAdmin = user.role < 110;

        user.isAdmin = isAdmin;
      }

      state.current = user;

      if (user?.status === PENDING_USER_STATUS) {
        state.showEmailConfirmation = true;
      }
    },
    [TOGGLE_EMAIL_CONFIRMATION](state) {
      state.showEmailConfirmation = !state.showEmailConfirmation;
    }
  });
};

export default userReducer;
